"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preValidateProps = exports.preValidateForm = exports.preValidate = exports.default = void 0;

var _lodash = require("lodash");

var _tools = require("./utils/tools");

var _helper = require("./utils/helper");

var _action = require("./action");

/**
 * 前置验证Form表单
 * @param {array}    data      验证规则
 * @param {object}   options   配置
 * @config {object}  form      form验证
 * @config {string}  path      路径
 * @param {function} successCb 成功回调
 * @param {function} errorCb   失败回调
 */
var preValidateForm = function preValidateForm(data, options) {
  if (!Array.isArray(data)) {
    return Promise.reject(Error('验证规则数据应为数组'));
  }

  var form = options.form;

  if (!form) {
    return Promise.reject(Promise.reject(Error('选项中form必须')));
  }

  var names = [];
  data.forEach(function (item) {
    names.push(item.target);
  });
  return new Promise(function (resolve, reject) {
    var _form$validateFields;

    (_form$validateFields = form.validateFields(names, {}, function (errors, values) {
      if (errors) {
        reject(errors);
      } else {
        resolve(values);
      }
    })) === null || _form$validateFields === void 0 ? void 0 : _form$validateFields.then(function (values) {
      resolve(values);
    }, function (errorInfo) {
      reject(errorInfo);
    });
  });
};
/**
 * 前置验证属性
 * @param {array}    data      验证规则
 * @param {object}   options   配置
 * @config {string}  path      路径
 * @config {string}  CRE_ID    数据ID，非必传
 * @param {function} successCb 成功回调
 * @param {function} errorCb   失败回调
 */


exports.preValidateForm = preValidateForm;

var preValidateProps = function preValidateProps(data, options) {
  if (!Array.isArray(data)) {
    return Promise.reject(Error('验证规则数据不对'));
  }

  var nameMap = options.nameMap;
  var findItem = {};
  var values = {};
  var errors = {};
  var firstMessage = '';
  data.forEach(function (item) {
    var _get2;

    findItem = (_get2 = (0, _lodash.get)(nameMap, (0, _helper.resolvePath)(item.target))) === null || _get2 === void 0 ? void 0 : _get2._data;

    if (findItem.value && findItem.value === item.value) {
      (0, _lodash.set)(values, item.target, item.value);
    } else {
      (0, _lodash.set)(errors, item.target, item.message);

      if (item.message) {
        firstMessage = item.message;
      }
    }
  });

  if ((0, _tools.isObject)(errors) && Object.keys(errors).length) {
    (0, _action.toast)(firstMessage);
    return Promise.reject(errors);
  }

  return Promise.resolve(values);
};
/**
 * 前置验证
 * @param {object}    data      验证规则
 * @param {object}   options   配置
 */


exports.preValidateProps = preValidateProps;

var preValidate = function preValidate(data, options) {
  if (!(0, _tools.isObject)(data)) {
    return Promise.reject(Error('验证规则数据格式错误'));
  }

  try {
    var preItem = [];
    return Promise.all(Object.keys(data).map(function (key) {
      preItem = data[key];

      switch (key) {
        // form 验证
        case 'form':
          return preValidateForm(preItem, options);
        // value相同

        case 'props':
          return preValidateProps(preItem, options);

        default:
          return Promise.reject(Error('只支持props和form校验'));
      }
    }));
  } catch (error) {
    return Promise.reject(error);
  }
};

exports.preValidate = preValidate;
var _default = preValidate;
exports.default = _default;